<template>
  <transition :name="$style.customSlide">
    <div v-if="show" :class="[$style.container, $style[type]]">
      <base-icon :name="getIconName" />
      <div v-m-l="16">
        <p :class="$style.title" v-text="$t(title)"></p>
        <p v-if="description" :class="$style.description" v-text="$t(description)"></p>
      </div>
    </div>
  </transition>
</template>

<script>
import { events } from './events';

import BaseIcon from 'atoms/base/BaseIcon';

const showingTime = 3400;

const ALERT_ICONS_MAP = {
  info: 'notifications_info',
  danger: 'notifications_alert-circle',
  success: 'basic_circle-checked',
};

export default {
  name: 'CapustaAlert',
  components: {
    BaseIcon,
  },
  mounted() {
    events.$on('show', this.init);
  },
  data() {
    return {
      show: false,
      type: 'info',
      title: 'unknown warning',
      description: '',
    };
  },
  computed: {
    getIconName() {
      return ALERT_ICONS_MAP[this.type];
    },
  },
  methods: {
    showAlert(params) {
      this.type = params.type;
      this.title = params.title;
      this.description = params.description || '';
      this.show = true;
    },
    async init(params) {
      if (!params) {
        return;
      }

      if (this.show) {
        this.show = false;
        clearTimeout(this._timer);
        await this.$nextTick();
      }

      this.showAlert(params);

      this._timer = setTimeout(() => {
        this.show = false;
      }, showingTime);
    },
  },
};
</script>

<style lang="sass" module>
  .container
    position: fixed
    top: 10px
    right: 10px
    +flexbox
    +align-items(flex-start)
    width: calc(100% - 20px)
    padding: 16px
    border-radius: 4px
    background: var(--color-white)
    box-shadow: 0px 1px 2px rgba(189, 189, 189, 0.5)
    z-index: 9999
    word-break: break-word

    +respond-to(medium)
      top: 30px
      right: 30px
      width: calc(100% - 60px)
      max-width: 352px

  .info
    border: 1px solid var(--color-grey-2)
    color: var(--color-grey-2)

  .danger
    border: 1px solid var(--color-red)
    color: var(--color-red)

  .success
    border: 1px solid var(--color-green)
    color: var(--color-green)

  .title
    +font-type(semi-bold, 14, 24)

  .description
    margin-top: 5px
    +font-type(regular, 12, 17)
    color: var(--color-black-2)

  .customSlide
    &:global(-enter-active),
    &:global(-leave-active)
      transition: all 0.46s ease-out

    &:global(-enter),
    &:global(-leave-to)
      top: 0
      right: 10px
      transform: translateY(-100%)

    &:global(-enter-to)
      top: 10px
      right: 10px
      transform: translateY(0)

    +respond-to(medium)
      &:global(-enter),
      &:global(-leave-to)
        top: 30px
        right: 0
        transform: translateX(100%)

      &:global(-enter-to)
        top: 30px
        right: 30px
        transform: translateX(0)
</style>
